import { createContext, useContext, useState, type ReactNode } from 'react';

interface FooterInfo {
  totalRows: number;
  selectedRows?: number;
}

interface FooterContextValue {
  footerInfo: FooterInfo | null;
  setFooterInfo: (info: FooterInfo | null) => void;
}

const FooterContext = createContext<FooterContextValue | null>(null);

export function FooterProvider({ children }: { children: ReactNode }) {
  const [footerInfo, setFooterInfo] = useState<FooterInfo | null>(null);

  return (
    <FooterContext.Provider value={{ footerInfo, setFooterInfo }}>
      {children}
    </FooterContext.Provider>
  );
}

export function useFooter() {
  const context = useContext(FooterContext);
  if (!context) {
    throw new Error('useFooter must be used within a FooterProvider');
  }
  return context;
}
